import * as React from "react";
import {
  Grid,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const HelpDialog = ({ open, close }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={() => close()}>
      <DialogTitle id="alert-dialog-title">
        {t("helpdialog.title")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{t("helpdialog.line1")}</DialogContentText>
        <br />
        <DialogContentText>{t("helpdialog.line2")}</DialogContentText>
        <br />
        <DialogContentText>{t("helpdialog.line3")}</DialogContentText>
        <br />
        <DialogContentText>{t("helpdialog.line4")}</DialogContentText>
        <br />
        <DialogContentText>{t("helpdialog.line5")}</DialogContentText>
        <br />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close()} autoFocus>
          {t("dialog.gotit.button")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default HelpDialog;